import { Component, OnInit, ViewChild } from '@angular/core';
import { loadMessages } from 'devextreme/localization';
import { TranslateService } from '@ngx-translate/core';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { CheckValidation } from 'src/app/shared/services/hr/CheckValidation.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'app-holiday',
  templateUrl: './holiday.component.html',
  styleUrls: ['./holiday.component.scss']
})
export class HolidayComponent implements OnInit {
  button = {}
  customDataSource: any;
  date = new Date()
  addpopup: string = '';
  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  currentLang: any;
  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;

  constructor(public gt: genericCustomStoreService
    , private validation: CheckValidation, public Objects: ObjectsService, public translate: TranslateService) {
    gt.seturl("HolidayType");
    gt.submit();
    this.customDataSource = gt.customDataSource;
    this.button = Objects.button;
    this.validateAsync = this.validateAsync.bind(this);
    this.validateAsyncForEn=this.validateAsyncForEn.bind(this)

    this.currentLang = localStorage.getItem(
      this.LOCALIZATION_LOCAL_STORAGE_KEY
    );

    loadMessages({
      en: { "Yes": this.translate.instant('personal.yes'), "No": this.translate.instant('personal.no') }
    });

  }
  ngOnInit(): void { }
  validateAsync(params: any) {
    var id = params.data.id ?? 0;
    return this.validation.asyncCheckNameValue(params.value, id, "HolidayType");
  }

  validateAsyncForEn(params: any) {
    var id = params.data.id ?? 0;
    return this.validation.asyncCheckNameValue(params.value, id, "HolidayType", 'CheckName', 'NameEn');
  }
  updateRow(options: any) {
    options.newData = Object.assign(options.oldData, options.newData);
    options.newData.dateOfRegistration = this.date
  }
  onInitNewRow(e: any) {
    e.data.dateOfRegistration = this.date
    this.addpopup = this.translate.instant('tableinfo.addbutton')
  }
  onEditingStart() {
    this.addpopup = this.translate.instant('tableinfo.editbutton')

  }

  addrowfun(name: string) {
    return this.gt.addrow(name)
  }

}
